// extracted by mini-css-extract-plugin
module.exports = {"tooltipWrapper":"ylnVAQHV","rightWrapper":"JL15T9Rl","tooltipTitleLabel":"wDWmHX2A","categoryLabel":"pEGVBsWn"};